module.exports = __webpack_public_path__ + "static/media/sound_hot.3aa2bbb.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/sound_hot.wav
// module id = AD2W
// module chunks = 1